import { Compass } from "lucide-react";

import { useLocale, type Locale } from "@/lib/i18n";

const TEXT: Record<Locale, string> = {
  sv: "Den här guiden är skriven för dig som ska flytta till Spanien och inte har bott här tidigare. Den ger översikten – hur delarna hänger ihop och i vilken ordning de görs. Myndighetsärendena börjar alltid med NIE, och den detaljerade handläggningen finns i kunskapsbanken längre ner på sidan.",
  en: "This guide is written for families moving to Spain who have not lived here before. It gives the overview – how the pieces fit together and in which order they are done. The official steps always begin with the NIE, and the detailed procedure is in the Knowledge Hub further down the page.",
  es: "Esta guía está pensada para familias que se mudan a España y no han vivido aquí antes. Ofrece la visión general: cómo encajan las piezas y en qué orden se hacen. Los trámites empiezan siempre por el NIE y el detalle está en el centro de recursos, más abajo en la página.",
};

/** Kort ram i toppen av varje öppen guide: vem den är skriven för och vad den inte är. */
export function NewcomerNote({ locale }: { locale?: Locale }) {
  const urlLocale = useLocale();
  const loc = locale ?? urlLocale;

  return (
    <div className="mx-auto max-w-3xl px-5 pt-8">
      <p className="flex gap-3 rounded-xl border border-border bg-sand/60 p-4 text-sm leading-relaxed text-muted-foreground">
        <Compass className="mt-0.5 size-4 shrink-0 text-primary" aria-hidden="true" />
        <span>{TEXT[loc] ?? TEXT.sv}</span>
      </p>
    </div>
  );
}
